import { useTranslation } from 'react-i18next';
import { DatePicker, Form, Modal } from 'antd';
import { FileUpload } from 'components/common/file-upload';
import styles from './client-insurance-modal.module.scss';
import type { IClientInsuranceModalProps, IInsuranceFormFields } from './types';
import { validateInsuranceFile } from './utils';

export const ClientInsuranceModal = (props: IClientInsuranceModalProps) => {
  const {
    fileContent,
    fileLabel,
    initialValidityPeriod,
    isSubmitting = false,
    open,
    submitText,
    title,
    onCancel,
    onSubmit,
  } = props;
  const { t } = useTranslation('client');
  const [form] = Form.useForm<IInsuranceFormFields>();

  const handleFinish = async ({ fileList, validityPeriod }: IInsuranceFormFields) => {
    const file = fileList?.[0]?.originFileObj;
    if (!fileContent && !file) return;

    await onSubmit({
      file,
      validityPeriod,
    });
  };

  return (
    <Modal
      rootClassName={styles.modal}
      title={title}
      open={open}
      width={460}
      confirmLoading={isSubmitting}
      okText={submitText}
      cancelText={t('common:cancel')}
      afterClose={() => form.resetFields()}
      afterOpenChange={(isOpen) => {
        if (isOpen) form.setFieldsValue({ validityPeriod: initialValidityPeriod });
      }}
      onCancel={onCancel}
      onOk={() => form.submit()}>
      <Form form={form} layout='vertical' onFinish={handleFinish}>
        {fileContent ? (
          <Form.Item label={fileLabel || t('insurance_policy')}>{fileContent}</Form.Item>
        ) : (
          <Form.Item
            name='fileList'
            label={t('insurance_policy')}
            valuePropName='fileList'
            getValueFromEvent={(event) => event?.fileList}
            rules={[
              {
                validator: (_, files) =>
                  validateInsuranceFile(files, t('insurance_policy_required'), t('insurance_policy_too_large')),
              },
            ]}>
            <FileUpload
              accept='.pdf,.jpg,.jpeg,.png'
              maxCount={1}
              title={t('insurance_choose_file')}
              description={t('insurance_file_requirements')}
              selectButtonText={t('insurance_select')}
              replaceButtonText={t('insurance_replace')}
            />
          </Form.Item>
        )}

        <Form.Item
          name='validityPeriod'
          label={t('insurance_validity_period')}
          rules={[{ required: true, message: t('insurance_validity_required') }]}>
          <DatePicker.RangePicker className={styles.datePicker} format='YYYY-MM-DD' allowClear={false} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
